<script setup lang="ts">
import type { Drill } from 'modules/Step/models/Drill';
import type { Step } from 'modules/Step/models/Step';
import { mdiBook } from '@quasar/extras/mdi-v7';
import { computed } from 'vue';
import { prepareCmsHtml } from '../../../utilities/cmsHtmlSanitizer';

interface Props {
  drill?: Drill | null;
  instructions: Step['instructions'];
}

const props = defineProps<Props>();

const sanitizedInstructions = computed(() =>
  prepareCmsHtml(props.instructions),
);
</script>

<template>
  <q-card
    flat
    class="q-pa-none q-ma-none bg-transparent"
  >
    <q-card-section class="bg-transparent q-pa-none">
      <q-list>
        <q-item>
          <q-item-section avatar>
            <q-avatar
              size="md"
              color="dark"
              text-color="accent"
              square
              :icon="mdiBook"
            />
          </q-item-section>
          <q-item-section>
            <q-item-label>
              {{ $t('THEORY_STEP') }}
            </q-item-label>
            <q-item-label caption>
              {{ $t('THEORY_STEP_INFORMATION_TEXT') }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
    <q-card-section class="bg-transparent">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="sanitizedInstructions"></div>
    </q-card-section>
  </q-card>
</template>
